// react
import { ReactNode, useContext } from 'react';

// router
import { Link as RouterLink } from 'react-router-dom';

// types
import { Account, Project } from '../../../@types';

// i18n
import { useTranslation } from 'react-i18next';

// context
import { ContextUser } from '../../../App.context';
import { ContextProject } from '../../pages/Project/Project.context';

// mui
import { Link, LinkProps, Typography } from '@mui/material';

// props
export interface LinkAccountProps extends LinkProps {
	account: Account;
	children?: ReactNode;
	project?: Project;
	[x: string]: unknown;
}

export const LinkAccount = ({ account, children, project, ...props }: LinkAccountProps) => {
	// context
	const { project: projectContext } = useContext(ContextProject);
	const { user } = useContext(ContextUser);

	// hooks
	const { t } = useTranslation();

	// vars
	const projectId = project ? project.idWbg : projectContext?.idWbg;
	const hasAccess = user?.isWbg || user?.abac?.accounts?.includes(account.id);

	let link = <Typography>{t('na')}</Typography>;

	if (children) {
		return <>{children}</>;
	} else if (account) {
		if (account.id && account.name && projectId && hasAccess) {
			link = (
				<Link
					component={RouterLink}
					fontWeight={600}
					sx={{ wordBreak: 'break-word' }}
					to={`/project/${projectId}/account/${account.id}`}
					underline="hover"
					{...props}>
					{account.name}
				</Link>
			);
		} else if (account.name) {
			link = <Typography fontWeight={500}>{account.name}</Typography>;
		}
	}

	return link;
};
